import { useState, useEffect } from 'react';

import { EligibilityInfo } from 'api/get-app-init-details';
import { getUserEligibility } from 'api/get-user-eligibility';

interface EligibilityData {
  loading: boolean | null;
  eligible?: boolean | null;
  details?: EligibilityInfo | null;
  error?: boolean | null;
  errorName?: string | null;
  productSubType?: string | null;
  coverageExperience?: string | null;
  productSubTypes?: string[];
}

export const useUserEligibility = (isAuthenticated: boolean | undefined) => {
  const [eligibilityData, setEligibilityData] = useState<EligibilityData>({
    eligible: null,
    details: null,
    loading: null,
    error: null,
  });

  useEffect(() => {
    const fetchEligibility = async () => {
      if (!isAuthenticated) {
        return;
      }

      try {
        setEligibilityData({
          loading: true,
        });
        const data = await getUserEligibility(isAuthenticated);
        setEligibilityData({
          eligible: data.eligible,
          details: data.details,
          errorName: data.errorName,
          productSubType: data.productSubType,
          coverageExperience: data.coverageExperience,
          productSubTypes: data.productSubTypes,
          loading: false,
          error: Boolean(data.error),
        });
      } catch (error) {
        setEligibilityData({
          eligible: false,
          details: null,
          loading: false,
          error: true,
          errorName: error instanceof Error ? error.name : undefined,
        });
      }
    };

    fetchEligibility();
  }, [isAuthenticated]);

  return eligibilityData;
};
